import React, { FC } from 'react'
import styled from 'styled-components'
import { DescriptionTextStyled, SecondaryHeaderStyled } from '../../styles/shared'
import TextWithLinkStyled from '../common/textWithLinkStyled'
import { ScreenBreakpointSize } from '../../utils/enums'
import { getScreenBreakpointSize } from '../../utils/getScreenBreakpointSize'
import { StaticImage } from 'gatsby-plugin-image'

const ContainerStyled = styled.div`
  background-color: var(--background-gray);
  border: 1px solid var(--border-gray);
  border-radius: var(--border-radius-8);
  margin-right: var(--spacing-16);
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium, -1)}) {
    border-radius: 0;
    border-right: none;
    border-left: none;
    margin-right: 0;
    margin: 20px 0;
  }
`

const TextContent = styled.div`
  padding: var(--spacing-32) var(--spacing-32);
  align-self: end;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium, -1)}) {
    padding-left: var(--spacing-16);
    padding-right: var(--spacing-16);
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Medium,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Large, -1)}) {
  }
`

const CustomSectionTitleStyled = styled(SecondaryHeaderStyled)`
  font-size: var(--font-size-28);
`
const CustomDescriptionTextStyled = styled(DescriptionTextStyled)`
  margin-bottom: var(--spacing-16);
  margin-top: var(--spacing-16);
`
const LinkContainerStyled = styled.div`
  width: fit-content;
`

const WriteLikeNoOnesWatching: FC = () => {
  return (
    <ContainerStyled>
      <StaticImage aria-hidden="true" src={'../../assets/images/cyborg-1.jpg'} alt="Cyborg bubble dome" />
      <TextContent>
        <div>
          <CustomSectionTitleStyled>Write fearlessly.</CustomSectionTitleStyled>
          <CustomDescriptionTextStyled>
            Note-taking services like Evernote, Google Keep, Notion, and Simplenote cannot prevent employees and
            governments from reading your data.
          </CustomDescriptionTextStyled>
          <CustomDescriptionTextStyled>
            Standard Notes features advanced security and privacy controls that protect your data against hacks, data
            breaches, government access, and even employee access.
          </CustomDescriptionTextStyled>
        </div>
        <LinkContainerStyled>
          <TextWithLinkStyled text={'Read how we protect your data'} targetUrl={'/privacy'} />
        </LinkContainerStyled>
      </TextContent>
    </ContainerStyled>
  )
}

export default WriteLikeNoOnesWatching
